import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MailchimpSubscribe from 'react-mailchimp-subscribe';

const url = 'https://thetownsquare.us17.list-manage.com/subscribe/post?u=a2437dac425557542681fe2ca&id=ef23f8689c';

class Form extends Component {
    state = {
		firstName: '',
		lastName: '',
		email: '',
        acceptsMarketing: true,
    }

    render() {
		let { firstName, lastName, email } = this.state;
        let { status, message, onValidated, onSuccess } = this.props;

        const submit = () => {
            email &&
            firstName &&
            email.indexOf("@") > -1 &&
            onValidated({
                EMAIL: email,
                FNAME: firstName,
                LNAME: lastName,
            });
		}

        if(status === 'success') {
            onSuccess();
        }

        return (
            <div className="slide-transition">
                <fieldset>
                    <div className="slide-holder">
                        <div id="reset-slide" className="slide-wrapper">
                            <header className="bg-green ptop20 pbot20">
                                <h4 className="text-white text-center mtop0 mbot0">Sign up to our newsletter</h4>
                            </header>
                            <div className="inner no-footer">

                                <div className="bg-light-main bg-slightly-transparent transparent back">
                                    <div>
                                        <div className="reset-email">

                                            <div className="input">
                                                <i className="icon-user" />
                                                <input
													value={firstName}
													onChange={(e) => this.setState({ firstName: e.target.value })}
                                                    type="text"
                                                    placeholder="First name"
                                                    className={'form-control'}
                                                />
                                                <div className="clearfix" />
                                            </div>

                                            <div className="input">
                                                <i className="icon-user" />
                                                <input
													value={lastName}
													onChange={(e) => this.setState({ lastName: e.target.value })}
                                                    type="text"
                                                    placeholder="Last name"
                                                    className={'form-control'}
                                                />
                                                <div className="clearfix" />
                                            </div>

                                            <div className="input">
                                                <i className="icon-envelope" />
                                                <input
													value={email}
													onChange={(e) => this.setState({ email: e.target.value })}
                                                    type="email"
                                                    placeholder="Email"
                                                    className={'form-control'}
                                                />
                                                <div className="clearfix" />
                                            </div>

                                            <div className="input input--checkbox">
                                                <i className="icon-envelope" />
                                                <input
                                                    type="checkbox"
                                                    id={'acceptsMarketing'}
                                                    checked={this.state.acceptsMarketing}
                                                    onChange={() => this.setState({
                                                        acceptsMarketing: !this.state.acceptsMarketing
                                                    })}
                                                />
                                                <div className="fake-checkbox" />
                                                <label htmlFor="acceptsMarketing">I would like to receive emails from startup-club.co.uk</label>
                                                <div className="clearfix" />
                                            </div>

                                        </div>
                                        <div className="clearfix" />
                                        <footer className="bg-green text-center text-white">
                                            <button
                                                className="p20 btn btn-none btn-block"
                                                onClick={submit}
                                                disabled={!this.state.acceptsMarketing}
                                            >Sign up</button>
                                        </footer>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </fieldset>

                {status === "sending" &&
                    <div style={{
                        position: 'relative',
                        top: '15px',
                        color: "#063dd6"
                    }}>sending...</div>
                }
                {status === "error" && (
                    <div
                        style={{
                            position: 'relative',
                            top: '15px',
                            color: "red"
                        }}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                )}
                {status === "success" && (
                    <div
                        style={{
                            position: 'relative',
                            top: '15px',
                            color: "green"
                        }}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                )}
            </div>
        );
    }
}

const SignupForm = ({ history }) => (
    <MailchimpSubscribe
        url={url}
        render={({ subscribe, status, message }) => (
            <Form
                status={status}
                message={message}
                onValidated={formData => subscribe(formData)}
                onSuccess={() => {
                    setTimeout(() => history.push('/'), 2000)
                }}
            />
        )}
    />
);

export default withRouter(SignupForm);


// WEBPACK FOOTER //
// ./src/js/components/SignupForm.js